import { EllipsisVertical } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Card, CardHeader } from '../../../components/ui/card';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';
import type { UnifiedPrompt } from '../hooks/use-prompt-source';
import PromptCard from './PromptCard';

interface PromptFolderSectionProps {
  title: string;
  prompts: UnifiedPrompt[];
  emptyMessage: string;
  onInsertPrompt: (prompt: UnifiedPrompt) => Promise<void>;
  onEditPrompt: (prompt: UnifiedPrompt) => void;
  onDeletePrompt: (prompt: UnifiedPrompt) => void;
  onRenameFolder?: () => void;
  onDeleteFolder?: () => void;
}

export default function PromptFolderSection({
  title,
  prompts,
  emptyMessage,
  onInsertPrompt,
  onEditPrompt,
  onDeletePrompt,
  onRenameFolder,
  onDeleteFolder,
}: Readonly<PromptFolderSectionProps>): JSX.Element {
  return (
    <Card>
      <CardHeader className="items-center">
        <h3 className="m-0 text-[0.8125rem] font-bold text-muted-foreground">{title}</h3>
        {onRenameFolder || onDeleteFolder ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button size="sm" variant="ghost" className="h-7 w-7 min-h-0 px-0">
                <EllipsisVertical className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {onRenameFolder ? (
                <DropdownMenuItem onClick={onRenameFolder}>Rename</DropdownMenuItem>
              ) : null}
              {onDeleteFolder ? (
                <DropdownMenuItem onClick={onDeleteFolder} className="text-destructive">
                  Delete
                </DropdownMenuItem>
              ) : null}
            </DropdownMenuContent>
          </DropdownMenu>
        ) : null}
      </CardHeader>

      {prompts.length === 0 ? (
        <p className="m-0 text-xs text-muted-foreground">{emptyMessage}</p>
      ) : (
        <div className="flex flex-col gap-2.5">
          {prompts.map((prompt) => (
            <PromptCard
              key={prompt.id}
              prompt={prompt}
              onInsertPrompt={onInsertPrompt}
              onEditPrompt={onEditPrompt}
              onDeletePrompt={onDeletePrompt}
            />
          ))}
        </div>
      )}
    </Card>
  );
}
